module.exports = __webpack_public_path__ + "img/Link_Line_2_20px_Icon.5aab9d22.svg";